import { render } from "./TopNavbar.vue?vue&type=template&id=3d4c6997"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"

import "./TopNavbar.vue?vue&type=style&index=0&id=3d4c6997&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__